import React from 'react';
import './About.css';

function About() {
  return (
    <div className="about">
      <section className="about-header">
        <h1>About Us</h1>
        <p>The story behind 42 Pets</p>
      </section>

      <section className="about-content">
        <div className="content-wrapper">
          <div className="about-section">
            <h2>Our Story</h2>
            <p>
              42 Pets was founded with a simple mission: to create technology that helps 
              pet owners provide the best possible care for their beloved companions. 
              As pet owners ourselves, we understand the challenges and joys that come 
              with caring for our furry friends.
            </p>
            <p>
              What started as a small project to track our own pets' feeding schedules 
              has grown into a suite of applications designed to support pet owners in 
              every aspect of pet care. We believe that technology should make life easier, 
              not more complicated, and that philosophy guides everything we build.
            </p>
          </div>

          <div className="about-section">
            <h2>Our Mission</h2>
            <p>
              We're dedicated to building intuitive, powerful mobile applications that 
              enhance the relationship between pets and their owners. Every line of code 
              we write is with the goal of making pet care more accessible, more organized, 
              and more enjoyable.
            </p>
          </div>

          <div className="about-section">
            <h2>Our Values</h2>
            <div className="values-grid">
              <div className="value-card">
                <h3>🎯 Pet-First Design</h3>
                <p>Every feature is designed with the well-being of pets at its core</p>
              </div>
              <div className="value-card">
                <h3>💡 Simplicity</h3>
                <p>We believe the best technology is the technology that gets out of your way</p>
              </div>
              <div className="value-card">
                <h3>🔒 Privacy</h3>
                <p>Your data and your pets' information are always protected</p>
              </div>
              <div className="value-card">
                <h3>🌟 Quality</h3>
                <p>We're committed to building apps that are reliable, fast, and beautiful</p>
              </div>
            </div>
          </div>

          <div className="about-section">
            <h2>Why 42 Pets?</h2>
            <p>
              The number 42 is, of course, a nod to Douglas Adams' "The Hitchhiker's Guide 
              to the Galaxy" - the answer to the ultimate question of life, the universe, 
              and everything. While we may not have all the answers to life's big questions, 
              we're passionate about helping you answer the important questions about your 
              pets' care and well-being.
            </p>
          </div>

          <div className="about-section contact-section">
            <h2>Get in Touch</h2>
            <p>
              We love hearing from pet owners! Whether you have feedback, suggestions, 
              or just want to share a photo of your pet, we'd love to connect with you.
            </p>
            <p>
              Have questions or need support? Feel free to reach out to us through the 
              App Store or visit our support page.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default About;
